import React from "react";
import { Box, Typography, Button, CardMedia } from "@mui/material";
import { useNavigate } from "react-router-dom";
import lock from "../../images/svg/lock.png";

export default function NotPermission() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        width: "100%",
        height: "92%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        mx: "auto",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: "40%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          mx: "auto",
          justifyContent: "center",
          bgcolor: "#ffff",
          p: 3,
          borderRadius: 3,
          boxShadow: 3,
        }}
      >
        <CardMedia
          sx={{ mx: "auto", mb: 2, width: "15%", height: "auto" }}
          component="img"
          alt="lock"
          src={lock}
        />
        <Typography variant="h6">
          کاربر گرامی شما به این صفحه دسترسی ندارید
        </Typography>
        <Button
          size="large"
          variant="text"
          color="secondary"
          sx={{ mt: 3 }}
          onClick={() => {
            navigate("/");
          }}
        >
          صفحه نخست
        </Button>
      </Box>
    </Box>
  );
}
